import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";

import moment from "moment";
import download from "../../../Images/download.svg";

import { UrlPath } from "../../../config/routeConfig";

import { TopBar } from '../../shared/topBar/TopBar';
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { SBGrid } from "../../UiComponents/SBAAGgrid";


import { getTaxEntityListAction } from "../../actions/investorAccounts";
import { Modal } from "react-bootstrap";
import { sbaAxios } from "../../utils/sbaAxios";
import { SBNotify } from "../../utils/sbNotify";
import { deleteTaxEntityAPI } from "../../../config/apiConfig";
import { ToastContainer } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import { getCustomSettings } from "../../../config/apiConfig";


const TaxEntityNameRenderer = (props) => {
    const history=useNavigate();
    const { data, value } = props;
    return (
      <span style={{cursor: 'pointer' }} onClick={()=>{history(`/Investor/Accounts/details/${data.TaxEntityId}`)}}>
        {value}
      </span>
    );
};


export const InvestorAccounts = () => {
    
    const Level = [{ BreadCrumb: "CRM >", Routes: `${UrlPath.Investor}` }, { BreadCrumb: `Accounts`, Routes: `${UrlPath.InvestorAccounts}` }];
    const dispatch=useDispatch();
    const history=useNavigate();
    
    const Gstate=useSelector(state=>state);
    const isEditable = Gstate.authorizationData.isEditable;
    const taxEntityList=Gstate.investorAccounts.taxEntityList;
    const taxEntityListLoading=Gstate.investorAccounts.isTaxEntityListLoading;

    const [isDeleteAccount,setIsDeleteAccount]=useState(false);
    const [toDeleteAccount,setToDeleteAccount]=useState(null);
    const [render, setRender] = useState(false);

    const [colDef, setColDef] = useState();
    const [appliedFilter, setAppliedFilter] = useState(null);
    const taxEntityRef=useRef();
    
    useEffect(()=>{
        document.title = "Investor Accounts";

    }, []);

    useEffect(()=>{
        dispatch(getTaxEntityListAction());
        fetchGridData();
    },[render])
    const ActionCellRenderer = (props) => {
        const isEditable = useSelector(state => state.authorizationData.isEditable);
        const [isEdit, setIsEdit] = useState(isEditable);
        useEffect(() => { setIsEdit(isEditable) }, [isEditable]);
        return (<div className="h-100 d-flex justify-content-center align-items-center ">
            <i class={`fas fa-edit ${isEdit ? "text-success"   : "text-secondary"}  mx-1`}  onClick={() => {isEdit && navigateToEdit(props.data.TaxEntityId)  }}></i>
            <i class={`fas fa-trash ${isEdit ? "text-danger"  : "text-secondary"}  mx-1`} onClick={() => {isEdit && setToDeleteAccount(props.data); setIsDeleteAccount(true)}}></i>
        </div>)
    }

    const TaxEntityColumnDef = [
        { headerName: "Tax Entity Name", field: "TaxEntityName", tooltipField: 'TaxEntityName', cellRenderer: TaxEntityNameRenderer , minWidth:400 },
        { headerName: "Abbreviation", field: "Abbreviation", tooltipField: 'Abbreviation' },
        { headerName: "Status Name", field: "TaxEntityStatusName", tooltipField: 'TaxEntityStatusName' },
        { headerName: "Action", field: "", cellRenderer: ActionCellRenderer ,floatingFilter: false ,maxWidth:100 },
    ]; 
    const defaultColDef = {
        resizable: true, sortable: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter',minWidth:100
    };

    const getCustomSetting = async () => {
        try {
            const response = await sbaAxios({ url: `${getCustomSettings}${1017}` });
            if (response) {

                const apiColDef = JSON.parse(response.CustomSettingsValue);
                const apiFilters = JSON.parse(response.CustomFilterValue);
                const formattedDef = apiColDef.map(item => ({
                    ...item,
                    "field": item.colId,
                    cellRenderer: item.colId === "Action"
                        ? ActionCellRenderer
                        : (item.colId === "TaxEntityName"
                            ? TaxEntityNameRenderer
                            :" "
                            
                        ),
                }));
                return { columns: formattedDef, filters: apiFilters };
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    };

    const fetchGridData = async () => {
        try {
            const customSettings = await getCustomSetting();
            setColDef(customSettings.columns);
            setAppliedFilter(customSettings.filters);
        } catch (error) {
            console.error("Error fetching custom settings:", error);
        }
    };


    const deleteAccount=()=>{
        if(toDeleteAccount?.TaxEntityId)
        {
            sbaAxios({ url: `${deleteTaxEntityAPI}${toDeleteAccount.TaxEntityId},0` }).then(e => {
                if(e===1)
                {
                    SBNotify({ Msg: 'Selected Account Has Been Deleted Successfully' });
                    setRender(!render);
                }
                else if (e===2)
                {
                    SBNotify({type:'error',Msg: 'Unable to Delete Account. The Selected Account is Linked to a Portfolio in the System.' });   
                }
                else if(e===3)
                {
                    SBNotify({type:'error',Msg: 'Unable to Delete Account. The Selected Account has Linked Documents.' });
                }
                else
                {
                    SBNotify({type:'error',Msg: 'Unable to Delete Account.' });   
                }

               


                setIsDeleteAccount(false);
                setToDeleteAccount(null);
            }).then(e => {
                console.log("Error Deleting the Account", e);
                setIsDeleteAccount(false);
                setToDeleteAccount(null);
            }
            );
        }
    };
    const navigateToEdit=(entityID)=>{
        history(`${UrlPath.InvestorAccountEdit}${entityID}`, { state: { ActiveTab: "General"} })
    }
    const navigateToAdd=()=>{
        history(`${UrlPath.InvestorAccountAdd}`);
    }
    
    return (
        <>
            <TopBar label={"Investor Accounts"} />
            <div  className="mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="container-fluid">
                    <div className="bg-white p-3 border rounded">
                    <div class="d-flex justify-content-end gap-2 " style={{ width: '75%' }}>
                                <button className="p-sm-btn" disabled={!isEditable} onClick={()=>{isEditable && navigateToAdd()}}><i className="fa-solid fa-plus"></i>Add Account</button>
                            </div>
                        {taxEntityListLoading ? <><LoadingScreen /></> : <div>
                            <SBGrid ref={taxEntityRef} column={colDef} row={taxEntityList} filters={appliedFilter} componentID={1017} gridStyle={{ width: '75%', height: '70vh' }}></SBGrid>
                            </div>}
                    </div>
                </div>
            </div>
            <InvestorAccountModal showModal={isDeleteAccount} setShowModal={setIsDeleteAccount} title={"Delete Account ?"} operation={deleteAccount}>
                <p>
                    The selected Account will be deleted permanently. Are you sure?
                </p>
            </InvestorAccountModal>
            <ToastContainer/>
        </>
    )
}
const InvestorAccountModal=({showModal,setShowModal,title,operation,children})=>{
    return <Modal show={showModal}>
    <Modal.Header closeButton onClick={setShowModal}>
      <Modal.Title>
      {title}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
      {children}
      </p>
    </Modal.Body>
    <Modal.Footer>
      <button className="s-sm-btn mx-1" onClick={()=>{setShowModal(false)}}>
        Cancel
      </button>
      <button
        className="p-sm-btn mx-1"
        onClick={()=>{operation()}}
      >
        Yes
      </button>
    </Modal.Footer>
  </Modal>
}